<template>
  <div class="page event-management">
    


    <div class="content">
        <div class="dashboard">
        <heading  :title="'Help Center'"></heading>
        

        <div class="help_contain">

        <div class="topic">


          <div class="title">
            <p
            :class="{ activeLink: current === 'title' }"
            >Managing Event Content</p>
          </div>
          <div class="items">

            <p 
            id="agenda"
            @click="toggleActive"
            :class="{ activeLink: current === 'agenda' }"
            >Agenda</p>

            <p
            id="speakers"
            @click="toggleActive"
            :class="{ activeLink: current === 'speakers' }"
            >Speakers</p>

            <p
            id="sponsors"
            @click="toggleActive"
            :class="{ activeLink: current === 'sponsors' }"
            >Sponsors</p>

            <p
            id="venue"
            @click="toggleActive"
            :class="{ activeLink: current === 'venue' }">Venues</p>
          </div>

     

          <div class="title">
            <p>Managing Event Information</p>
          </div>
          <div class="items">

            <p id="tickets"
            @click="toggleActive"
            :class="{ activeLink: current === 'tickets' }"
            >Tickets</p>

            <p
            id="attendees"
            @click="toggleActive"
            :class="{ activeLink: current === 'attendees' }"
            >Add Attendees</p>

            <p
            id="email_attendees"
            @click="toggleActive"
            :class="{ activeLink: current === 'email_attendees' }"
            >Emails to Attendees</p>

            <p
            id="attendees_list"
            @click="toggleActive"
            :class="{ activeLink: current === 'attendees_list' }"
            >Attendees List</p>

            <p
            id="guest_list"
            @click="toggleActive"
            :class="{ activeLink: current === 'guest_list' }"
            >Guest List</p>

            <p
            id="badges"
            @click="toggleActive"
            :class="{ activeLink: current === 'badges' }"
            >Badges</p>

            <p
            id="checkin"
            @click="toggleActive"
            :class="{ activeLink: current === 'checkin' }"
            >Check-in</p>

          </div>

          <div class="title">
            <p>Managing Design</p>
          </div>

          <div class="title">
            <p>Managing Exhibitors</p>
          </div>

          <div class="title">
            <p>Managing Reports</p>
          </div>          
          
        </div>

        <div class="help_content">

  <!-- MANAGING EVENT CONTENT SECTION -->

          <div class="agenda_info" v-if="current === 'agenda'">
          <h1>Managing Event Content</h1>
          
          <h2>Agenda</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>

          <h2>How to add an agenda item</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
       </div>
   
        
        <transition>
          <div class="speakers_info"  v-if="current === 'speakers'">
          <h1>Managing Event Content</h1>
          
          <h2>Speakers</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>

          <h2>How to add a speaker</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
       </div>
        </transition>

        <transition>
          <div class="sponsors_info"  v-if="current === 'sponsors'">
          <h1>Managing Event Content</h1>
          
          <h2>Sponsors</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>

          <h2>How to add a sponsor</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
       </div>
        </transition>       


        <transition>
          <div class="venue_info"  v-if="current === 'venue'">
          <h1>Managing Event Content</h1>
          
          <h2>Venues</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>

          <h2>How to add a venue</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
       </div>
        </transition>  

 <!-- MANAGING EVENT ATTENDEES SECTION -->


        <transition>
          <div class="tickets_info"  v-if="current === 'tickets'">
          <h1>Managing Event Information</h1>
          
          <h2>Tickets</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>

          <h2>How to add Tickets</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
          
          <h2>Free Tickets</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>

          <h2>Paid Tickets</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>      
          
          <h2>Donation Tickets</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>

          </div>
        </transition>  

        <transition>
          <div class="attendees_info"  v-if="current === 'attendees'">
          <h1>Managing Event Content</h1>
          
          <h2>Add Attendees</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>

          <h2>How to add attendees</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
          </div>
        </transition> 

        <transition>
          <div class="email_attendees_info"  v-if="current === 'email_attendees'">
          <h1>Managing Event Content</h1>
          
          <h2>Email Attendees</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>

          <h2>How to email attendees</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
          </div>
        </transition> 

        <transition>
          <div class="attendees_list_info"  v-if="current === 'attendees_list'">
          <h1>Managing Event Content</h1>
          
          <h2>Attendees List</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>

          <h2>How to manage attendees list</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
          </div>
        </transition> 

        <transition>
          <div class="guest_list_info"  v-if="current === 'guest_list'">
          <h1>Managing Event Content</h1>
          
          <h2>Guest List</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>

          <h2>How to manage guest list</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
          </div>
        </transition> 

        <transition>
          <div class="badges_info"  v-if="current === 'badges'">
          <h1>Managing Event Content</h1>
          
          <h2>Badges</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>

          <h2>How to create badges</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
          </div>
        </transition> 

        <transition>
          <div class="checkin_info"  v-if="current === 'checkin'">
          <h1>Managing Event Content</h1>
          
          <h2>Check In</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>

          <h2>How to manage check in</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
          </div>
        </transition> 

        </div>

        </div>

        </div>
        <div class="help_menu">
          


        </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Title from "@/components/Title.vue";
import Upload from "@/components/Upload.vue";
import Popup from "@/components/Popup.vue";

import { Datetime } from "vue-datetime";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");
export default {
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    datetime: Datetime,
    heading: Title,
    popup: Popup,
    upload: Upload
  },
  data() {
    return {
      current: null,
    };
  },
  methods: {
    goTo(page) {
      let vm = this;
      this.cover = true;
      setTimeout(function() {
        vm.$router.push({ name: page });
      }, 500);
    },
    toggleActive(event) {
      this.current = event.target.id;
    },
  },
};


</script>

<style>
</style>